// Query profiler client. Profiles ONE statement on a connection via session
// profiling (SHOW PROFILE) — per-stage time breakdown + a SHOW STATUS counter
// delta + wall timing + EXPLAIN. Profiling EXECUTES the statement, so a write is
// run exactly once (the UI warns first). Returns:
//   { available, note?, readOnly, runs, wallMs:[…], wallMedian, wallMin,
//     stageSeconds, rowCount, stages:[{status,seconds,cpuUser?,cpuSys?,blockIn?,blockOut?}],
//     statusDelta:{…}, explain:{columns,rows}, error? }
import { api } from './api.js';

export const profileQuery = (connectionId, database, sql, runs) =>
  api.post('/api/tools/query-profile', {
    connectionId: Number(connectionId) || 0,
    database: database || '',
    sql,
    runs: runs || 0,
  });
